var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefreshCw05Gray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh-cw-05"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.2265 6.44732C10.0876 7.75226 9.34819 8.97513 8.1247 9.68151C6.09196 10.8551 3.4927 10.1586 2.31909 8.1259L2.19409 7.9094M1.77306 5.5543C1.91197 4.24935 2.65136 3.02649 3.87485 2.3201C5.9076 1.1465 8.50686 1.84297 9.68046 3.87571L9.80546 4.09222M1.74658 9.03382L2.11261 7.6678L3.47863 8.03382M8.5212 3.9678L9.88722 4.33382L10.2532 2.9678",
    stroke: "#6E7781",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCw05Gray);
export default __webpack_public_path__ + "static/media/refresh-cw-05-gray.be1ad0e50ba5d2fef98723caa0f66f71.svg";
export { ForwardRef as ReactComponent };